module.exports = "/images/vendor/flag-icon-css/flags/1x1/sr.svg?be27d1ae7006588ccd01ae8083081944";